export default __webpack_public_path__ + "static/media/IMG-20250105-WA0007.9a8800d9.jpg";